export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/comment-f7195f79872e57a94577905063c0125f.svg";